import { cn } from '@/utils/cn';

export function DateBlock({
  weekday,
  day,
  month,
  today,
  className,
}: {
  weekday: string;
  day: string | number;
  month: string;
  today?: boolean;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'w-[52px] shrink-0 rounded-ctl border px-0 py-s1 text-center',
        today ? 'border-ds-teal-line bg-ds-teal-tint' : 'border-ds-line bg-ds-bg',
        className,
      )}
    >
      <span
        className={cn(
          'block text-[11px] font-semibold uppercase leading-4 tracking-wide',
          today ? 'text-ds-teal' : 'text-ds-muted',
        )}
      >
        {weekday}
      </span>
      <span
        className={cn(
          'block text-[20px] font-semibold leading-6 tabular-nums',
          today ? 'text-ds-teal' : 'text-ds-text',
        )}
      >
        {day}
      </span>
      <span className="block text-[11px] leading-[14px] text-ds-muted">{month}</span>
    </div>
  );
}
